// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Modal_wrapper__fdg_A","overlay":"Modal_overlay__8gTQi","modal":"Modal_modal__3Geqy","title":"Modal_title__skjNW","closeButton":"Modal_closeButton__GqPsw"};